import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import AuthLayout from "./AuthLayout";
import { Button, Input } from "../../components/ui";
import { authService } from "../../services/auth";
import { CAPTCHA } from "../../services/config";
import { useToast } from "../../context/ToastContext";
import { useTheme } from "../../context/ThemeContext";

export default function Login({ admin = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const { theme } = useTheme();
  const [form, setForm] = useState({ email: "", password: "" });
  const [captcha, setCaptcha] = useState("");
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.email || !form.password) return setError("กรุณากรอกอีเมลและรหัสผ่าน");
    if (CAPTCHA.siteKey && !captcha && !CAPTCHA.masterToken) return setError("กรุณายืนยันว่าคุณไม่ใช่บอท");
    setLoading(true);
    try {
      const p = await authService.login({ ...form, captchaToken: captcha });
      if (admin) {
        const ok = await authService.verifySuperUser();
        if (!ok) {
          await authService.logout();
          throw new Error("บัญชีนี้ไม่มีสิทธิ์ super_user");
        }
        toast("เข้าสู่หลังบ้านแล้ว", "success");
        navigate("/admin", { replace: true });
        return;
      }
      toast(`ยินดีต้อนรับ ${p.displayName || ""}`, "success");
      navigate(location.state?.from || "/chat", { replace: true });
    } catch (err) {
      setError(err.message);
      setCaptcha("");
      setCaptchaKey(Date.now());
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      variant={admin ? "admin" : undefined}
      title={admin ? "เข้าสู่ระบบผู้ดูแล" : "ยินดีต้อนรับกลับมา"}
      subtitle={admin ? "สำหรับบัญชี super_user เท่านั้น" : "เข้าสู่ระบบด้วยอีเมลและรหัสผ่านของคุณ"}
      footer={admin ? <Link to="/login">เข้าสู่ระบบผู้ใช้ทั่วไป</Link> : <>ยังไม่มีบัญชี? <Link to="/register">สมัครฟรี</Link></>}
    >
      <form onSubmit={submit} noValidate className="auth-form">
        <Input label="อีเมล" type="email" icon="mail" placeholder="you@example.com" value={form.email} onChange={set("email")} autoComplete="username" autoFocus />
        <Input
          label="รหัสผ่าน"
          type="password"
          icon="lock"
          placeholder="••••••••"
          value={form.password}
          onChange={set("password")}
          autoComplete="current-password"
          right={!admin ? <Link to="/forgot" className="field-link">ลืมรหัสผ่าน?</Link> : null}
        />
        {CAPTCHA.siteKey ? (
          <div className="mb-16">
            <Turnstile key={captchaKey} sitekey={CAPTCHA.siteKey} theme={theme} onVerify={setCaptcha} onExpire={() => setCaptcha("")} onError={() => setCaptcha("")} />
          </div>
        ) : null}
        {error ? <div className="form-error" role="alert">{error}</div> : null}
        <Button type="submit" variant="primary" block size="lg" loading={loading}>
          {loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
        </Button>
      </form>
    </AuthLayout>
  );
}
